/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";

type NotificationRow = {
  _id: string;
  title: string;
  message: string;
  notificationType: string;
  pushType?: string;
  senderType?: string;
  receiverType?: string;
  createdAt?: string;
};

export type NotificationsListProps = {
  rows: NotificationRow[];
  count: number;
  page: number;
  onPageChange: (e: any, p: number) => void;
  loading: boolean;
  deleteNotificationApi: (id: string) => void
};
const NotificationsList: React.FC<NotificationsListProps> = ({ rows, count, page, onPageChange, loading, deleteNotificationApi }) => {
  const [selectedId, setSelectedId] = useState<string>("");
  const columns: GridColDef<NotificationRow>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 200,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "senderType",
      headerName: "Sender Type",
      valueGetter: (params) =>
        (params?.row?.senderType || "")
          .toLowerCase()
          .replace(/_/g, " "),
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "pushType",
      headerName: "Push Type",
      valueGetter: (params) =>
        (params?.row?.pushType || "")
          .toLowerCase()
          .replace(/_/g, " "),
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "receiverType",
      headerName: "Receiver Type",
      valueGetter: (params) =>
        (params?.row?.receiverType || "")
          .toLowerCase()
          .replace(/_/g, " "),
      editable: false,
      sortable: false,
    },
    {
      minWidth: 150,
      field: "createdAt",
      headerName: "Created Date",
      valueGetter: (params) => (params?.row?.createdAt ? new Date(params.row.createdAt).toLocaleDateString() : "-"),
      editable: false,
      sortable: false,
    },
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton onClick={() => { setSelectedId(row?._id); setOpen(true); }}>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
          getRowId={(row: any) => row?._id}
        />
      </div>
      <ConfirmationModal
        text={"Are you sure you want to delete this Notification?"}
        openModal={open}
        setOpenModal={setOpen}
        handleSubmit={() => deleteNotificationApi(selectedId)}
      />
    </>
  );
}

export default NotificationsList;
